const AllPosts = () => {
  return (
    <div>AllPosts</div>
  )
}
export default AllPosts